import {Doctor, Event, FullCalendarEvent} from "@/lib/types/models.ts";

export const mapAppEventToFullCalendarEvent = (event: Event, doctors: Doctor[]): FullCalendarEvent => {
    const title = event.name;
    const doctor = doctors.find((d) => d.id === event.doctor_id);
    const backgroundColor = event.event_type === "surgery" ? "#f87171" : doctor?.color || "#60a5fa";

    return {
        id: event.id.toString(),
        title,
        start: event.start_at,
        end: event.end_at,
        extendedProps: {
            doctor_id: event.doctor_id,
            patient_id: event.patient_id,
            history_entry: event.history_entry,
            event_type: event.event_type,
            description: event.description,
        },
        backgroundColor,
        borderColor: backgroundColor,
    };
};